import { User } from "types";

/**
 * Access types in the system
 */
export enum AccessType {
  OWNER = "OWNER",
  ADMIN = "ADMIN",
  MEMBER = "MEMBER",
  GUEST = "GUEST",
}

/**
 * Check if user is owner
 */
export const isOwner = (user?: User | null): boolean => {
  return user?.config.access_type === AccessType.OWNER;
};

/**
 * Check if user is admin
 */
export const isAdmin = (user?: User | null): boolean => {
  return user?.config.access_type === AccessType.ADMIN;
};

/**
 * Check if user is owner or admin
 */
export const isOwnerOrAdmin = (user?: User | null): boolean => {
  return isOwner(user) || isAdmin(user);
};

/**
 * Check if user is member
 */
export const isMember = (user?: User | null): boolean => {
  return user?.config.access_type === AccessType.MEMBER;
};

/**
 * Check if user is guest
 */
export const isGuest = (user?: User | null): boolean => {
  return user?.config.access_type === AccessType.GUEST;
};

/**
 * Check if user can update other users
 */
export const canUpdateUser = (
  currentUser?: User | null,
  targetUser?: User | null
): boolean => {
  if (!currentUser) return false;

  // Users can always update their own profile
  if (currentUser.id === targetUser?.id) return true;

  // Owners and admins can update other users
  return isOwnerOrAdmin(currentUser);
};

/**
 * Check if user can delete other users
 */
export const canDeleteUser = (
  currentUser?: User | null,
  targetUser?: User | null
): boolean => {
  if (!currentUser || !targetUser) return false;

  // Cannot delete yourself
  if (currentUser.id === targetUser.id) return false;

  // Only owners and admins can delete users
  return isOwnerOrAdmin(currentUser);
};

/**
 * Check if user can update organization
 */
export const canUpdateOrg = (user?: User | null): boolean => {
  return isOwnerOrAdmin(user);
};
